import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";

class DenounceService extends BaseService {

  constructor() {
    super();
    this.TAG = "DenounceService";

    this.logUtils = new LogUtils();
  }

  async getAgentUserDenounces(agentId) {
    let denounces = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/denounces/agent/${agentId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar as denúncias."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar as denúncias."
        };
      }

      denounces = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getAgentUserDenounces", err);

      return {
        status: -2,
        msg: "Não foi possível retornar as denúncias"
      };
    }

    return {
      status: 1,
      msg: "As denúncias foram retornados com sucesso.",
      data: denounces
    };
  }

  async getDenounce(denounceId) {
    let denounce = {};

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/denounces/${denounceId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível retornar a denúncia."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar a denúncia."
        };
      }

      denounce = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getDenounce", err);

      return {
        status: -2,
        msg: "Não foi possível retornar a denúncia"
      };
    }

    return {
      status: 1,
      msg: "A denúncia foi retornada com sucesso.",
      data: denounce
    };
  }

  async updateDenounce({ denounceId, denounceStatusId, description, agentFeedback, agentVisit,
                         agentUserId, isAnonymous, populationUserActualPoints, agentUserActualPoints }) {
    let denounce = null;
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.PUT,
          `${settings.MANAGEMENT_SERVICE_URL}/denounces`,
          this.getDefaultHeaders(true),
          {
            denounceId: denounceId,
            denounceStatusId: denounceStatusId,
            description: description,
            agentFeedback: agentFeedback,
            agentVisit: agentVisit,
            agentUserId: agentUserId,
            isAnonymous: isAnonymous,
            populationUserActualPoints: populationUserActualPoints,
            agentUserActualPoints: agentUserActualPoints
          },
          true
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível atualizar a denúncia."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

      denounce = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updateDenounce", err);

      return {
        status: -2,
        msg: "Não foi possível atualizar a denúncia"
      };
    }

    return {
      status: 1,
      msg: "A denúncia foi atualizado com sucesso.",
      data: denounce
    };
  }

}

export default DenounceService;